module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<span>Copyright &copy; 2013-' +
__e( currentYear ) +
' Zmags</span>\n\n';
 if (typeof CONFIG !== "undefined" && CONFIG.debug) { ;
__p += '\n    <p/><p>\n    <b>Viewer url</b>: ' +
__e( CONFIG.viewerApiBaseUrl ) +
'<br>\n    <b>Admin url</b>: ' +
__e( CONFIG.adminApiBaseUrl ) +
'\n    </p>\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/common/DefaultFooterView.tpl
// module id = 1513
// module chunks = 0